import { Badge, BadgeProps } from '@mantine/core';

/** @deprecated Use `Pill` from `@zorro/design-system/v2/Pill` instead */
export type IBadgeProps = BadgeProps;

/** @deprecated Use `Pill` from `@zorro/design-system/v2/Pill` instead */
export const ZorroBadge = ({
  variant = 'filled',
  size = 'lg',
  ...props
}: IBadgeProps) => {
  return (
    <Badge
      variant={variant}
      size={size}
      styles={{
        root: {
          letterSpacing: '-0.5px',
          fontWeight: 400,
          textTransform: 'none',
          padding: '4px 16px',
        },
      }}
      {...props}
    />
  );
};
